export function OnboardingBanner() {
  return null;
}
